<ng-container *ngrxLet="selectSharedEvent; let sharedAlert">
  <!--  COULD BE 2 CASES-->
  <!--  1. IF ALERT REMOVED-->
  <!--  2. IF ARCHIVE FOR THIS ALERT REMOVED-->
  <ng-container *ngIf="sharedAlert; else entityRemoved">
    <app-thumbnail
      *ngIf="dialogData"
      [checkPermissionEnabled]="false"
      [isShareVisible]="false"
      [allowDialogOpen]="false"
      [optionsInput]="dialogData.options"
      [rtl]="false"
      [events]="dialogData.events"
      [searchEvents]="dialogData.searchEvents"
      [objects]="dialogData.objects"
      [cameraId]="dialogData.cameraId"
      [defaultThumbnail]="dialogData.defaultThumb"
      [seconds]="dialogData.seconds"
      [type]="dialogData.type"
      [showObjects]="dialogData.showObjects"
      [allowTrack]="dialogData.allowTrack"
      [alertName]="dialogData.alertName"
      [isDialog]="true"
      [name]="dialogData.name"
      [shareName]="dialogData?.shareName"
      [isSharedAlert]="true"
      [selectedCamera]="dialogData.selectedCamera"
      [controlEventOptions]="dialogData.controlEventOptions"
      [online]="true"
      [initialTs]="sharedAlert.timestamp - 10000"
    ></app-thumbnail>
  </ng-container>
</ng-container>

<ng-template #entityRemoved>
  <div class="error-container">
    <span class="ui-icon-warning"></span>
    <div class="description">The video has failed to upload. Please contact you person at Lumana.ai</div>
    <ui-button type="primary" text="Contact" (click)="openMail()"></ui-button>
  </div>
</ng-template>
